import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import config from "../config";
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { Functions } from "@material-ui/icons";

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  problem: {
    width: "100%",
  },
  form_wrapper: {
    margin: "20px 0"
  }
});

class UserView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      ratings: [],
      image_url: null
    };
  }

  
  componentDidMount() {
    this.setState({ loading: true });
    return fetch(
      config.backend_url + "users/" + this.props.match.params.name
    ).then((response) => {
      response.json().then((json) => {
        this.setState({ ratings: json.ratings, image_url: json.image_url, loading: false });
      });
    });
  }

  getRatingDiff(lastRating, beforeRating) {
    var diff = lastRating - beforeRating;
    if (diff >= 0) {
      return "+" + String(diff);
    }
    return "-" + String(diff);
  }

  render() {
    const ratings = this.state.ratings;
    var lastRating = 0;
    var beforeRating = 0;
    for (var r in ratings) {
      beforeRating = lastRating;
      lastRating = Math.ceil(ratings[r].rating);
    }
    const { classes } = this.props;

    const handleSubmit = () => {
      const formData = new FormData();
      formData.append('user_id', this.props.user_id)
      formData.append('name', this.state.input_name)
      formData.append('file', this.state.input_file)

      this.setState({ submitting: true })
      fetch(config.backend_url + "update/user", {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
        },
        body: formData,
      }).then((response) => {
        response.json().then((json) => {
          this.setState({ submitting: false, input_name: '', input_file: null })
          this.props.handleUserUpdate(this.props.user_id)
        });
      });
    }
    return (
      <center>
        <div>
          <img src={this.state.image_url} align="middle" width="100" height="100"/>
          <h2>{this.props.match.params.name}</h2>
          <h2>
            <font size="3">{beforeRating}</font>→{lastRating} (
            {this.getRatingDiff(lastRating, beforeRating)})
          </h2>
          <LineChart align="center"
            width={300}
            height={300}
            data={ratings}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="rating"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
            />
          </LineChart>


          <div>
            <TwitterShareButton
              className={styles["post__footer-sns-twitter"]}
              title={
                beforeRating +
                "→" +
                lastRating +
                "(" +
                this.getRatingDiff(lastRating, beforeRating) +
                ") #謎コン"
              }
              url={
                "https://" +
                window.location.hostname +
                "/users/" +
                this.props.match.params.name
              }
            >
              <TwitterIcon size={32} round />
            </TwitterShareButton>
            <FacebookShareButton
              className={styles["post__footer-sns-facebook"]}
              url={
                "https://" +
                window.location.hostname +
                "/users/" +
                this.props.match.params.name
              }
              quote={
                beforeRating +
                "→" +
                lastRating +
                "(" +
                this.getRatingDiff(lastRating, beforeRating) +
                ") #謎コン"
              }
            >
              <FacebookIcon size={32} round />
            </FacebookShareButton>
          </div>
          
        </div>
      </center>
    );
  }
}

UserView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withStyles(styles)(UserView);
